import { customizeError } from '@chilecompra/react-kit'
import { DISABLED_CONTRACT_TEXT } from '../../config/settings/constant'
import { makeActionCreator } from '../../config/store/utils'
import { getContacts } from '../../services/seller'

export const GET_COMPANY_CONTACT_INFORMATION = 'GET_COMPANY_CONTACT_INFORMATION'
export const GET_COMPANY_CONTACT_INFORMATION_ERROR = 'GET_COMPANY_CONTACT_INFORMATION_ERROR'
export const GET_COMPANY_CONTACT_INFORMATION_SUCCESS = 'GET_COMPANY_CONTACT_INFORMATION_SUCCESS'
export const onGetCompanyContactInformation = makeActionCreator(GET_COMPANY_CONTACT_INFORMATION)
export const onGetCompanyContactInformationError = makeActionCreator(GET_COMPANY_CONTACT_INFORMATION_ERROR, 'payload')
export const onGetCompanyContactInformationSuccess = makeActionCreator(
  GET_COMPANY_CONTACT_INFORMATION_SUCCESS,
  'payload'
)
export const onGetCompanyContactInformationThunk = payload => async dispatch => {
  dispatch(onGetCompanyContactInformation())

  try {
    const { data } = await getContacts({
      actionType: GET_COMPANY_CONTACT_INFORMATION,
      dni: payload.dni
    })

    return dispatch(
      onGetCompanyContactInformationSuccess({
        contacts: data?.payload?.map(contact => {
          return {
            contactType: contact.tipoContacto.map(type => type.toLowerCase()),
            email: contact.email,
            name: contact.nombre,
            phone: contact.fono,
            position: contact.cargo,
            // FIXME: https://github.com/babel/babel-eslint/issues/799
            salesUnit: contact.sucursal.replace('[' + DISABLED_CONTRACT_TEXT + ']', '').trim()
          }
        })
      })
    )
  } catch (error) {
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        reason = 'FORBIDDEN_ERROR'
        break
      case 404:
        reason = 'DNI_DOES_NOT_MATCH_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }

    return dispatch(
      onGetCompanyContactInformationError({
        error: customizeError({ originialError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}
